import { render, staticRenderFns } from "./VendorManager.vue?vue&type=template&id=3e40e8ef&scoped=true&"
import script from "./VendorManager.vue?vue&type=script&lang=js&"
export * from "./VendorManager.vue?vue&type=script&lang=js&"
import style0 from "./VendorManager.vue?vue&type=style&index=0&id=3e40e8ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e40e8ef",
  null
  
)

export default component.exports